<template>
  <div class='partners'>
    <div class="kv">
      <img src="@/assets/goin/partnersKV.png" alt="">
    </div>
    <div class="container">
      <div class="box" v-for="(item, index) in 8" :key="index"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partners',
  components:{ 
    
  },
  data() {
    return {
        
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  }
}
</script>
<style lang='less' scoped>
.partners {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background: #DEDEDE;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .container {
    width: 1440px;
    margin: 0 auto;
    padding: 73px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .box {
      width: 339px;
      height: 255px;
      margin: 0 28px 31px 0;
      background: #fff;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>